import { Controller } from 'stimulus';
export default class extends Controller {
  handleClose(e) {
    const banner = e.target.closest('.page-banner');
    banner.remove();
    $.cookie(`_sofatutor_${banner.dataset.bannerType}_hidden`, 'true');
  }
}
